module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-800-dd94855e55bb7c78d89213e44445b3a8.webp";